import React, { useEffect } from "react";
import { observer } from "mobx-react";
import SidebarNav from "./SidebarNav";

// Mobile slide-in menu; sits over the page so the current view keeps its state.
function Drawer(props) {
	const { setDrawer, isDrawerOpen } = props;
	const close = () => setDrawer(false);

	useEffect(() => {
		if (!isDrawerOpen) return;
		const onKey = (e) => e.key === "Escape" && setDrawer(false);
		document.addEventListener("keydown", onKey);
		const prevOverflow = document.body.style.overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.removeEventListener("keydown", onKey);
			document.body.style.overflow = prevOverflow;
		};
	}, [isDrawerOpen, setDrawer]);

	return (
		<div className={`sn-drawer${isDrawerOpen ? " is-open" : ""}`} aria-hidden={!isDrawerOpen}>
			<div className="sn-backdrop" onClick={close} />
			<aside className="sn-drawer-panel" role="dialog" aria-modal="true" aria-label="Menu">
				{isDrawerOpen && <SidebarNav onClose={close} />}
			</aside>
		</div>
	);
}

export default observer(Drawer);
